module.exports = __webpack_public_path__ + "img/food_17.0e5190b6.jpg";